import SquadRegularText from './SquadRegularText';

export default SquadRegularText;
